"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isICanServe = void 0;
function isICanServe(serveService) {
    if (serveService === null) {
        return false;
    }
    if (typeof serveService != "object") {
        return false;
    }
    if (typeof serveService.served !== "function") {
        return false;
    }
    return true;
}
exports.isICanServe = isICanServe;
//# sourceMappingURL=ICanServe.js.map